// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"8":"162eb5b69bf3896f","45":"3dc25260aefe1cbf","152":"ad9e5489515084a5","163":"b8ea4305d5001592","298":"070bd283feeefa6a","357":"083cb66fdddcee97","664":"a92ca4dc25479b3e","728":"8bee74165ae3cdd8","967":"7633fe99d88549b8"}[chunkId] + ".js";
};